export const getPostOrganizationHolidaysList = id => `/organizations/${id}/holidays`
